













































































































































































































































































































































































































































































































import { Vue, Component, Ref, Watch  } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { AtributoMarketplace, CanalVendaMarketplace, CanalVendaMarketplaceProduto, DadosAdicionais, ImagemProduto, Loja, Produto, ProdutoMarketplace, TipoDeProduto, VideoMarketplace } from '@/models'
import CamposDeEndereco from '../ui/CamposDeEndereco.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import BuscaDeProdutoDropdown from '../produto/BuscaDeProdutoDropdown.vue'
import SeletorDeAtributoMarketplace from './SeletorDeAtributoMarketplace.vue'
import SeletorDeCategoriaGlobalMarketplace from './SeletorDeCategoriaGlobalMarketplace.vue'
import DataTableDeCrud from '../ui/DataTableDeCrud.vue'
import DialogoDeVideoMarketplace from './DialogoDeVideoMarketplace.vue'
import DialogoDeCanalDeVendaMarketplace from './DialogoDeCanalDeVendaMarketplace.vue'
import { FindProdutoMarketplaceUseCase } from '@/usecases/marketplace/FindProdutoMarketplaceUseCase'
import { UpdateProdutoMarketplaceUseCase } from '@/usecases/marketplace/UpdateProdutoMarketplaceUseCase'
import SeletorDeTabelaDePreco from '../tabeladepreco/SeletorDeTabelaDePreco.vue'
import { FindItemDaTabelaDePrecoUseCase, FindProdutoUseCase } from '@/usecases'
import WrapperDeUpload from '../ui/WrapperDeUpload.vue'
import { verificarQualidadeDoCadastro } from '@/shareds/marketplace-shareds'

@Component({
	components: {
		CamposDeEndereco,
		BuscaDeProdutoDropdown,
		SeletorDeAtributoMarketplace,
		SeletorDeCategoriaGlobalMarketplace,
		DataTableDeCrud,
		DialogoDeVideoMarketplace,
		DialogoDeCanalDeVendaMarketplace,
		SeletorDeTabelaDePreco,
		WrapperDeUpload,
	},
})
export default class DialogoProdutoMarketplace extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeProduto!: HTMLInputElement
	@Ref() dialogoDeVideoMarketplace!: DialogoDeVideoMarketplace
	@Ref() dialogoDeCanalDeVendaMarketplace!: DialogoDeCanalDeVendaMarketplace
	validarAoAbrir = false
	lojaSelecionada: Loja | null = null
	produtoMarketplaceEmEdicao: ProdutoMarketplace | null = null
	salvando = false
	mostra = false
	salvarNaAPI = true
	atributoCor: AtributoMarketplace | null = null
	atributoTamanho: AtributoMarketplace | null = null
	abas: string[] = ['Principal', 'Imagens', 'Descrição', 'Vídeos', 'Marketplaces', 'Dados Adicionais']
	tab: null | number = null
	headersVideos = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'URL', value: 'url' },
	]
	headersCanaisDeVenda = [
		{ text: 'Marketplace', value: 'canal.codigo' },
		{ text: 'Canal de Venda', value: 'canal.nome' },
		{ text: 'Preço', value: 'preco' },
	]
	reloadVideos = false
	reloadCanaisDeVenda = false
	editando = false
	dadosAdicionais = [] as DadosAdicionais[]
	imagens = [] as ImagemProduto[]
	mostraDialogoImagem = false
	editandoImagem = false
	indiceImagemEmEdicao: number | null = null
	imagemEmEdicao: ImagemProduto = { urlImagem: null, idProduto: null }
	uploadImagemEmAndamento = false

	findProdutoMarketplaceUseCase = new FindProdutoMarketplaceUseCase()
	updateProdutoUseCase = new UpdateProdutoMarketplaceUseCase()
	findItemDaTabelaDePrecoUseCase = new FindItemDaTabelaDePrecoUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	obrigatorio = obrigatorio
	AlertModule = AlertModule

	get abasPermitidas() {
		if (this.produtoMarketplaceEmEdicao?.produto) {
			return this.abas
		} else {
			return this.abas.filter(aba => aba === 'Principal')
		}
	}

	get tiposDeProdutos() {
		return { tipos: ['Padrão', 'Variante'] as TipoDeProduto [] }
	}

	get unidadesPossiveis() {
		return [
			'Unidade',
			'Quilogramas',
			'Gramas',
			'Miligramas',
			'Metros',
			'Centimetros',
			'Centimetros Quadrados',
			'Centimetros Cubicos',
			'Milimetros',
			'Milimetros Quadrados',
			'Milimetros Cubicos',
			'Libras',
			'Pes',
			'Pes Quadrados',
			'Pes Cubicos',
			'Polegadas',
			'Polegadas Quadradas',
			'Polegadas Cubicas',
			'Caixa',
		]
	}

	get generosPossiveis() {
		return [
			'masculino',
			'feminino',
			'menino',
			'menina',
			'unissex',
		]
	}

	get folderName() {
		return `publico/${window.location.host.split('.')[0]}/marketplace/imagens/produtos`
	}

	get isComVariantes() {
		return this.produtoMarketplaceEmEdicao && this.produtoMarketplaceEmEdicao.variantes && this.produtoMarketplaceEmEdicao.variantes.length > 0
	}

	get imagensAgrupadasPorVariante(): { nomeVariante: string; varianteId: string | null; items: { imagem: ImagemProduto; indiceGlobal: number }[] }[] {
		const list = this.imagens || []
		if (!this.produtoMarketplaceEmEdicao) return []
		const variantes = this.produtoMarketplaceEmEdicao.variantes || []
		if (this.isComVariantes && variantes.length > 0) {
			const grupos = new Map<string | null, { nomeVariante: string; varianteId: string | null; items: { imagem: ImagemProduto; indiceGlobal: number }[] }>()
			list.forEach((imagem, indiceGlobal) => {
				const id = imagem.idProduto
				let nome = 'Sem variante'
				if (id) {
					const v = variantes.find(vr => vr.produto && vr.produto.id === id)
					nome = (v && v.produto && (v.produto.nomeCompleto || v.produto.nome)) ? (v.produto.nomeCompleto || v.produto.nome) : id
				}
				if (!grupos.has(id)) grupos.set(id, { nomeVariante: nome, varianteId: id, items: [] })
				grupos.get(id)!.items.push({ imagem, indiceGlobal })
			})
			
			const ordenado: { nomeVariante: string; varianteId: string | null; items: { imagem: ImagemProduto; indiceGlobal: number }[] }[] = []
			variantes.forEach(vr => {
				if (vr.produto && grupos.has(vr.produto.id)) {
					ordenado.push(grupos.get(vr.produto.id)!)
					grupos.delete(vr.produto.id)
				}
			})
			grupos.forEach(g => ordenado.push(g))
			return ordenado
		}
		return [{ nomeVariante: 'Produto', varianteId: null, items: list.map((imagem, i) => ({ imagem, indiceGlobal: i })) }]
	}

	get canaisVendaNormalizado() {
		if (!this.produtoMarketplaceEmEdicao) return []
		return this.produtoMarketplaceEmEdicao.canaisVenda || []
	}

	@Watch('produtoMarketplaceEmEdicao.produto')
	async onChangeProduto(produtoAtual: Produto) {
		if (produtoAtual && !this.editando) {
			if (this.produtoMarketplaceEmEdicao && this.produtoMarketplaceEmEdicao.produto && this.lojaSelecionada && !this.validarAoAbrir) {
				const produtoId = this.produtoMarketplaceEmEdicao.produto.id

				try {
					const produtoJaCadastrado = await this.findProdutoMarketplaceUseCase.validaProdutoExistente(produtoId, this.lojaSelecionada.id)

					if (produtoJaCadastrado) {
						this.produtoMarketplaceEmEdicao.produto = null
						AlertModule.setError('Produto já cadastrado para sinconização com os markeplaces')
					}
				} catch(error) {
					AlertModule.setError(error)
				}

				if (this.produtoMarketplaceEmEdicao.produto && 
					this.produtoMarketplaceEmEdicao.produto.tipo === 'Com Variantes' &&
					(!this.produtoMarketplaceEmEdicao.variantes || this.produtoMarketplaceEmEdicao.variantes.length === 0)) {
					
					const variantes = await this.findProdutoUseCase.buscarVariantes(this.produtoMarketplaceEmEdicao.produto.id)

					this.produtoMarketplaceEmEdicao.variantes = []
					variantes.map(variante => {
						if (!this.produtoMarketplaceEmEdicao) return

						this.produtoMarketplaceEmEdicao.variantes.push({
							atributoCor: null,
							atributoTamanho: null,
							produto: variante,
						})

						if (variante.urlImagens && variante.urlImagens.length > 0) {
							variante.urlImagens.forEach(urlImagem => {
								this.imagens.push({
									urlImagem: urlImagem.imagemUrl,
									idProduto: variante.id,
								})
							})
						} else if (this.produtoMarketplaceEmEdicao.produto && this.produtoMarketplaceEmEdicao.produto.urlImagens && this.produtoMarketplaceEmEdicao.produto.urlImagens.length > 0) {
							this.produtoMarketplaceEmEdicao.produto.urlImagens.forEach(urlImagem => {
								this.imagens.push({
									urlImagem: urlImagem.imagemUrl,
									idProduto: variante.id,
								})
							})
						}else {
							this.imagens.push({
								urlImagem: '',
								idProduto: variante.id,
							})
						}
					})
				}
			}
		}
	}

	async mostrar(produtoMarketplace: ProdutoMarketplace, loja: Loja, validarAoAbrir = false, salvarNaAPI = true) {
		this.validarAoAbrir = validarAoAbrir
		const produtoMarketplaceEmEdicao = new Object() as ProdutoMarketplace
		this.dadosAdicionais = []
		this.tab = 0
		this.salvarNaAPI = salvarNaAPI

		if (produtoMarketplace.id && !validarAoAbrir) {
			produtoMarketplaceEmEdicao.id = produtoMarketplace.id

			const produtoDoBackend = await this.findProdutoMarketplaceUseCase.get(produtoMarketplace.id)
			
			const variantesComAtributos = produtoDoBackend.variantes && produtoDoBackend.variantes.length > 0
				? produtoDoBackend.variantes.map(variante => {
					const varianteCopy: any = {
						...variante,
						atributoCor: variante.atributoCor ? { ...variante.atributoCor } : null,
						atributoTamanho: variante.atributoTamanho ? { ...variante.atributoTamanho } : null,
					}
					return varianteCopy
				})
				: produtoDoBackend.variantes || []
			
			this.produtoMarketplaceEmEdicao = {
				...produtoDoBackend,
				variantes: variantesComAtributos,
				canaisVenda: produtoMarketplace.canaisVenda && produtoMarketplace.canaisVenda.length > 0
					? produtoMarketplace.canaisVenda.map(c => ({
						...c,
						canal: c.canal ? { ...c.canal } : null,
					}))
					: produtoDoBackend.canaisVenda || [],
				atributos: produtoDoBackend.atributos || [],
			}
			
			this.atributoCor = this.produtoMarketplaceEmEdicao.atributos && this.produtoMarketplaceEmEdicao.atributos.length > 0
				? this.produtoMarketplaceEmEdicao.atributos.filter(atributo => atributo.tipoAtributo === 'Cor')[0] || null
				: null
			this.atributoTamanho = this.produtoMarketplaceEmEdicao.atributos && this.produtoMarketplaceEmEdicao.atributos.length > 0
				? this.produtoMarketplaceEmEdicao.atributos.filter(atributo => atributo.tipoAtributo === 'Tamanho')[0] || null
				: null
			this.dadosAdicionais = this.produtoMarketplaceEmEdicao.dadosAdicionais ? JSON.parse(this.produtoMarketplaceEmEdicao.dadosAdicionais) : []
			this.imagens = this.produtoMarketplaceEmEdicao.imagens ? JSON.parse(this.produtoMarketplaceEmEdicao.imagens) : []
			this.editando = true
		} else {
			this.editando = false
			this.produtoMarketplaceEmEdicao = produtoMarketplace
			if (this.produtoMarketplaceEmEdicao.origem === null || this.produtoMarketplaceEmEdicao.origem === undefined) {
				this.produtoMarketplaceEmEdicao.origem = 'Nacional'
			}
			if (this.produtoMarketplaceEmEdicao.genero === null || this.produtoMarketplaceEmEdicao.genero === undefined) {
				this.produtoMarketplaceEmEdicao.genero = 'unissex'
			}
			if (this.produtoMarketplaceEmEdicao.unidade === null || this.produtoMarketplaceEmEdicao.unidade === undefined) {
				this.produtoMarketplaceEmEdicao.unidade = 'Unidade'
			}
			this.produtoMarketplaceEmEdicao.descricao = 'SEM DESCRIÇÃO'
			this.imagens = this.produtoMarketplaceEmEdicao.imagens ? JSON.parse(this.produtoMarketplaceEmEdicao.imagens) : []
		}
		
		this.lojaSelecionada = loja
		
		this.mostra = true
		
		this.$nextTick(() => {
			this.reloadComponenteDeCanaisDeVenda()
			
			if (validarAoAbrir) {
				setTimeout(() => {
					if (this.form) {
						this.form.validate()
					}
				}, 300)
			}
		})
	}

	esconder() {
		this.mostra = false
		this.produtoMarketplaceEmEdicao = null
		this.salvarNaAPI = true
	}

	verificarQualidadeDoCadastro() {
		if (!this.produtoMarketplaceEmEdicao) {
			return { completo: false, motivos: ['Produto não definido'] }
		}
		return verificarQualidadeDoCadastro(
			this.produtoMarketplaceEmEdicao,
			this.imagens,
			this.atributoCor,
			this.atributoTamanho,
		)
	}

	async salvar() {
		if (!this.produtoMarketplaceEmEdicao) return

		if (!this.lojaSelecionada) return
		if (!this.produtoMarketplaceEmEdicao.produto) return

		const verificacao = this.verificarQualidadeDoCadastro()
		
		if (verificacao.completo === false) {
			this.produtoMarketplaceEmEdicao.statusCadastro = 'INCOMPLETO'
			this.produtoMarketplaceEmEdicao.sincronizar = false
			this.produtoMarketplaceEmEdicao.motivos = verificacao.motivos
		} else if (verificacao.completo === true) {
			this.produtoMarketplaceEmEdicao.statusCadastro = 'COMPLETO'
			this.produtoMarketplaceEmEdicao.motivos = null
		} else {
			this.produtoMarketplaceEmEdicao.statusCadastro = 'VERIFICAR'
			this.produtoMarketplaceEmEdicao.motivos = verificacao.motivos
		}

		this.imagens = this.imagens.filter(imagem => imagem.urlImagem !== null && imagem.urlImagem.trim() !== '')
		
		if (this.isComVariantes) {
			const varianteSemImagem = this.produtoMarketplaceEmEdicao.variantes
				.filter(variante => variante && variante.produto && !this.imagens.map(imagem => imagem.idProduto).includes(variante.produto.id))

			if (varianteSemImagem.length > 0) {
				varianteSemImagem.forEach(variante => {
					this.imagens.push({idProduto: variante.produto.id, urlImagem: null})
				})
			}
		}

		if ((!this.imagens || this.imagens.length === 0) && !this.isComVariantes) {
			this.imagens.push({urlImagem: null, idProduto: null})
		}

		if (!this.produtoMarketplaceEmEdicao.canaisVenda) {
			this.produtoMarketplaceEmEdicao.canaisVenda = []
		}

		try {
			this.salvando = true

			if (!this.produtoMarketplaceEmEdicao.variantes || this.produtoMarketplaceEmEdicao.variantes.length === 0) {
				this.produtoMarketplaceEmEdicao.atributos = []
				if (this.atributoCor) {
					this.produtoMarketplaceEmEdicao.atributos.push(this.atributoCor)
				}
				if (this.atributoTamanho) {
					this.produtoMarketplaceEmEdicao.atributos.push(this.atributoTamanho)
				}
			}

			this.produtoMarketplaceEmEdicao.loja = this.lojaSelecionada
			this.produtoMarketplaceEmEdicao.nome = this.produtoMarketplaceEmEdicao.produto.nome
			this.produtoMarketplaceEmEdicao.dadosAdicionais = JSON.stringify(this.dadosAdicionais)
			this.produtoMarketplaceEmEdicao.imagens = JSON.stringify(this.imagens)

			if (this.salvarNaAPI) {
				if (this.produtoMarketplaceEmEdicao.id) {
					this.produtoMarketplaceEmEdicao = await this.updateProdutoUseCase.update(this.produtoMarketplaceEmEdicao)
				} else {
					this.produtoMarketplaceEmEdicao = await this.updateProdutoUseCase.create(this.produtoMarketplaceEmEdicao)
				}
			}
			
			if (!verificacao.completo) {
				AlertModule.setWarning('Produto salvo com status INCOMPLETO. Alguns campos obrigatórios não foram preenchidos.')
			}
			
			this.$emit('atualizar', this.produtoMarketplaceEmEdicao)

			this.esconder()
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	abrirDialogoParaAdicionarVideo() {
		this.dialogoDeVideoMarketplace.mostrar(null)
	}

	abrirDialogoParaEditarVideo(indice: any) {
		if(!this.produtoMarketplaceEmEdicao || !this.produtoMarketplaceEmEdicao.videos) return

		const videoEmEdicao = this.produtoMarketplaceEmEdicao.videos[indice]

		this.dialogoDeVideoMarketplace.mostrar(videoEmEdicao)
	}

	adicionarVideo(video: VideoMarketplace) {
		if (!this.produtoMarketplaceEmEdicao) return

		if (this.produtoMarketplaceEmEdicao.videos) {
			this.produtoMarketplaceEmEdicao.videos.push(video)
		} else {
			this.produtoMarketplaceEmEdicao.videos = [video]
		}

		this.reloadComponenteDeVideos()
	}

	salvarVideoEditado(videoEditado: VideoMarketplace) {
		if (!this.produtoMarketplaceEmEdicao) return

		const indiceEditado = this.produtoMarketplaceEmEdicao.videos.findIndex(video => video.id === videoEditado.id)

		if (indiceEditado >= 0) {
			this.produtoMarketplaceEmEdicao.videos.splice(indiceEditado, 1, videoEditado)
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	removerVideo(indice: any) {
		if (!this.produtoMarketplaceEmEdicao) return
		this.produtoMarketplaceEmEdicao.videos.splice(indice, 1)
		this.reloadComponenteDeVideos()
	}

	async abrirDialogoParaAdicionarCanalDeVenda() {
		if(!this.produtoMarketplaceEmEdicao) return

		const canais = this.produtoMarketplaceEmEdicao.canaisVenda?.map(canal => canal.canal) as CanalVendaMarketplace[] || []

		let precoDeTabela = 0
		if (this.produtoMarketplaceEmEdicao.tabelaDePreco && this.produtoMarketplaceEmEdicao.produto) {
			try {
				if (this.produtoMarketplaceEmEdicao.variantes && this.produtoMarketplaceEmEdicao.variantes.length > 0) {
					const itemDaTabelaDePreco = await this.findItemDaTabelaDePrecoUseCase.getByIdDoProduto(this.produtoMarketplaceEmEdicao.tabelaDePreco.id, this.produtoMarketplaceEmEdicao.variantes[0].produto.id)
					precoDeTabela = itemDaTabelaDePreco.precoFinalVarejo || 0
				} else {
					const itemDaTabelaDePreco = await this.findItemDaTabelaDePrecoUseCase.getByIdDoProduto(this.produtoMarketplaceEmEdicao.tabelaDePreco.id, this.produtoMarketplaceEmEdicao.produto.id)
					precoDeTabela = itemDaTabelaDePreco.precoFinalVarejo || 0
				}				
			} catch(error){
				AlertModule.setError('Preço não encontrado para tabela de preço ' + this.produtoMarketplaceEmEdicao.tabelaDePreco.nome)
			}
		}

		this.dialogoDeCanalDeVendaMarketplace.mostrar(null, canais, precoDeTabela)
	}

	abrirDialogoParaEditarCanalDeVenda(indice: any) {
		if(!this.produtoMarketplaceEmEdicao) return

		const canais = this.produtoMarketplaceEmEdicao.canaisVenda?.map(canal => canal.canal) as CanalVendaMarketplace[] || []
		const canalEmEdicao = this.produtoMarketplaceEmEdicao.canaisVenda[indice]

		this.dialogoDeCanalDeVendaMarketplace.mostrar(canalEmEdicao, canais, 0)
	}

	adicionarCanaisVenda(canalVendaProduto: CanalVendaMarketplaceProduto) {
		if (!this.produtoMarketplaceEmEdicao) return

		if (this.produtoMarketplaceEmEdicao.canaisVenda) {
			this.produtoMarketplaceEmEdicao.canaisVenda.push(canalVendaProduto)
		} else {
			this.produtoMarketplaceEmEdicao.canaisVenda = [canalVendaProduto]
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	salvarCanalEditado(canalVendaProduto: CanalVendaMarketplaceProduto) {
		if (!this.produtoMarketplaceEmEdicao) return

		const indiceEditado = this.produtoMarketplaceEmEdicao.canaisVenda.findIndex(canal => canal.canal?.codigo === canalVendaProduto.canal?.codigo)

		if (indiceEditado >= 0) {
			this.produtoMarketplaceEmEdicao.canaisVenda.splice(indiceEditado, 1, canalVendaProduto)
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	removerCanalDeVenda(indice: any) {
		if (!this.produtoMarketplaceEmEdicao) return
		this.produtoMarketplaceEmEdicao.canaisVenda.splice(indice, 1)
		this.reloadComponenteDeCanaisDeVenda()
	}

	reloadComponenteDeCanaisDeVenda() {
		this.reloadCanaisDeVenda = true
		setTimeout(() => {
			this.reloadCanaisDeVenda = false
		}, 10)
	}

	reloadComponenteDeVideos() {
		this.reloadVideos = true
		setTimeout(() => {
			this.reloadVideos = false
		}, 10)
	}

	getIconeMarketplace(codigo: any) {
		switch(codigo) {
			case '1':
				return require('@/assets/icones/amazon_logo.svg')
			case '2':
				return require('@/assets/icones/casasbahia_logo.svg')
			case '7':
				return require('@/assets/icones/mercado_livre_logo.svg')
			default:
				return 'sem'
		}
	}

	excluirDadoAdicional(key: string) {
		const indice = this.dadosAdicionais.findIndex(dadoAdicional => dadoAdicional.key === key)
		this.dadosAdicionais.splice(indice, 1)
	}

	adicionarDadoAdicional() {
		this.dadosAdicionais.push({
			key: '',
			value: '',
		})
	}

	abrirDialogoImagem(indice?: number) {
		if (indice === undefined) {
			this.editandoImagem = false
			this.indiceImagemEmEdicao = null
			this.imagemEmEdicao = { urlImagem: null, idProduto: null }
		} else {
			this.editandoImagem = true
			this.indiceImagemEmEdicao = indice
			const img = this.imagens[indice]
			this.imagemEmEdicao = { urlImagem: img.urlImagem, idProduto: img.idProduto }
		}
		this.$nextTick(() => {
			this.mostraDialogoImagem = true
		})
	}

	abrirDialogoImagemParaGrupo(grupo: any) {
		this.editandoImagem = false
		this.indiceImagemEmEdicao = null
		this.imagemEmEdicao = { urlImagem: null, idProduto: grupo.varianteId }
		this.$nextTick(() => {
			this.mostraDialogoImagem = true
		})
	}

	fecharDialogoImagem() {
		this.mostraDialogoImagem = false
		this.indiceImagemEmEdicao = null
		this.imagemEmEdicao = { urlImagem: null, idProduto: null }
		this.uploadImagemEmAndamento = false
	}

	confirmarDialogoImagem() {
		const novaImagem = {
			urlImagem: this.imagemEmEdicao.urlImagem,
			idProduto: this.imagemEmEdicao.idProduto,
		}
		if (this.editandoImagem && this.indiceImagemEmEdicao !== null) {
			this.$set(this.imagens, this.indiceImagemEmEdicao, novaImagem)
		} else {
			this.imagens.push(novaImagem)
		}
		this.fecharDialogoImagem()
	}

	removerImagem(indice: number) {
		this.imagens.splice(indice, 1)
	}
}
